import { render, staticRenderFns } from "./InnerCheckbox.vue?vue&type=template&id=12c68ae9"
import script from "./InnerCheckbox.vue?vue&type=script&lang=js"
export * from "./InnerCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12c68ae9')) {
      api.createRecord('12c68ae9', component.options)
    } else {
      api.reload('12c68ae9', component.options)
    }
    module.hot.accept("./InnerCheckbox.vue?vue&type=template&id=12c68ae9", function () {
      api.rerender('12c68ae9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/drc/components/crud-components/InnerCheckbox.vue"
export default component.exports